import { SignMethod } from '@/sign/models/sign-constants';

export class SignSettings {
  public isStampAllowed: boolean = false;
  public isStampRequired: boolean = false;
  public isShowDocumentFiles: boolean = false;
  public isCertAuthSelectorVisible: boolean = true;
  public submitBtnText: string = '';
  public fileNames: string = '';
  public visibleTabs: Array<SignMethod> = [];
  public enabledTabs: Array<SignMethod> = [];
  public confirmText: string = '';
  public dialogHeader: string = '';
  public isConfirmRequired: boolean = true;
  public dialogSubtitleHtml: string = '';
  public rejectSignPromiseOnError: boolean = false;
  public resetReadedKeys: boolean = false;
  public showCertExpirationWarning: boolean = true;
}

export class CloudProviderSettings {
  id: string = '';
  name: string = '';
  nameEn: string = '';
  icon?: any;

  constructor(id: string, name: string, nameEn: string, icon?: any) {
    this.id = id;
    this.name = name;
    this.nameEn = nameEn;
    this.icon = icon;
  }
}
